import React from 'react';

const CerezPolitikasi = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Çerez Politikası</h1>
      
      <div className="prose prose-blue max-w-none space-y-6">
        <div className="text-sm text-gray-500 mb-8">
          <span>SigortamOlsun Editörü</span>
          <span className="mx-2">•</span>
          <span>Güncelleme tarihi 30.01.2025</span>
          <span className="mx-2">•</span>
          <span>7 dk. okunma</span>
        </div>

        <div className="text-gray-600 space-y-6">
          <p>
            SigortamOlsun Sigorta Aracılık Hizmetleri Limited Şirketi ("Şirket") olarak, www.sigortamolsun.com web sitemizin ("Web Sitesi") ziyaretçilerinin gizlilik ve kişisel verilerinin korunması haklarını gözeterek ziyaretçilerimize daha iyi bir kullanım deneyimi sağlayabilmek için kişisel verilerini işlemekte ve internet çerezleri kullanmaktayız. Bu Çerez Kullanımı Politikası ("Politika"), tüm Web Sitesi ziyaretçilerimize ve kullanıcılarımıza hangi tür çerezlerin hangi koşullarda kullanıldığını açıklamaktadır.
          </p>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">Reşit Olmayanlar</h2>
            <p>
              18 yaşın altındaysanız Web Sitesi'ni ebeveynlerinizin refakati altında ziyaret etmeniz gerekmektedir. Ebeveynlerinizin refakati olmadan bu Web Sitesi'ni kullanmamanız ve hiçbir kişisel verinizi paylaşmamanız gerekmektedir.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">Çerez Nedir ve Hangi Amaçlarla Kullanılır?</h2>
            <p>
              Çerez, internet siteleri tarafından erişim sağladığınız bilgisayarınıza, cep telefonlarınıza, tabletlerinize veya diğer mobil cihazlarınıza kaydedilen küçük veri depolama dosyalarıdır. Bu dosyada Web Sitesi gezintinize ait bilgiler saklanır. Böylelikle erişim sağladığınız cihazlarınız Web Sitesi'ni tekrar kullandığınızda bu verilerinizi hatırlayacaktır.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">Hangi Tür Çerezleri Kullanıyoruz?</h2>
            <div className="space-y-4">
              <h3 className="font-medium text-gray-800">1. Kullanılması Zorunlu Olan Çerezler</h3>
              <p>Web Sitesi'nin düzgün şekilde çalışması için mutlaka gerekli olan çerezlerdir. Bu çerezlere, sistemin yönetilebilmesi, sahte işlemlerin önlenmesi için ihtiyaç vardır.</p>

              <h3 className="font-medium text-gray-800">2. İşlev Çerezleri</h3>
              <p>Size daha gelişmiş ve kolay bir kullanım deneyimi yaşatmak için kullanılan çerezlerdir. Örneğin önceki tercihlerinizi hatırlamak için kullanılır.</p>

              <h3 className="font-medium text-gray-800">3. Analiz/Performans Çerezleri</h3>
              <p>Web Sitesi'nin işleyişini analiz edip anlamımızı sağlayan ve sizinle etkileşime geçerek Web Sitesi'ni geliştirebilmemizi sağlamaktadır.</p>

              <h3 className="font-medium text-gray-800">4. Hedefleme/Reklam Çerezleri</h3>
              <p>Size, reklam içerikleri de dâhil olmak üzere, ilginizi çekebilecek içerikleri saptayarak sunmamız için kullanılmaktadır.</p>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">Çerezlerin Kullanımını Nasıl Kontrol Edebilirsiniz?</h2>
            <p>
              Tarayıcınızın ayarlarını değiştirerek çerezlere ilişkin tercihlerinizi kişiselleştirme imkanına sahipsiniz. Eğer kullanılan tarayıcı tipinden bağımsız olarak çerezleri engellerseniz Web Sitesi'nin bazı özellikleri düzgün çalışmayabilir.
            </p>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">Çerez Ayarları</h2>
            <div className="grid gap-6 mt-4">
              <div>
                <h3 className="font-medium text-gray-800">Google Chrome için:</h3>
                <ol className="list-decimal pl-6 mt-2 space-y-2">
                  <li>Chrome'u açın ve sağ üst köşedeki üç noktaya tıklayın</li>
                  <li>Ayarlar'ı seçin</li>
                  <li>Gelişmiş'e tıklayın</li>
                  <li>Gizlilik ve güvenlik'e tıklayın</li>
                  <li>Site Ayarları'na tıklayın</li>
                  <li>Çerezler ve site verileri'ne tıklayın</li>
                </ol>
              </div>

              <div>
                <h3 className="font-medium text-gray-800">Mozilla Firefox için:</h3>
                <ol className="list-decimal pl-6 mt-2 space-y-2">
                  <li>Firefox menüsünü açın</li>
                  <li>Seçenekler'i tıklayın</li>
                  <li>Gizlilik ve Güvenlik paneline gidin</li>
                </ol>
              </div>
            </div>
          </div>

          <div>
            <h2 className="text-xl font-semibold text-gray-800 mt-8 mb-4">İletişim</h2>
            <p>
              Çerez Politikası ile ilgili tüm soru ve görüşlerinizi bize iletmek için:<br />
              E-posta: info@sigortamolsun.com<br />
             
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CerezPolitikasi;